export const pagesStorageFilesEn = {
  alerts: {
    allMemberLabel: 'All Member',
    emptyMessage: 'No risk alerts detected in this category.',
    fetchErrorMessage: 'Failed to load risk alerts. Please try again later.',
    filter: {
      item: 'Item',
      placeholder: 'Filter...',
      policyTitle: 'Policy Title',
      riskLevel: 'Risk Level'
    },
    // 仮訳・要デザイナー確認（F-5）。description は6値とも新設。
    pattern: {
      anyoneWithLink: {
        description: 'Anyone with the link can access this item.',
        title: 'Link Published (Anyone)'
      },
      externalDomainShared: {
        description: 'This item is shared with an external domain.',
        title: 'External Domain Shared'
      },
      externalUserShared: {
        description: 'This item is shared with a specific external user or group.',
        title: 'External User Shared'
      },
      internalSpecific: {
        description: 'This item is shared with specific members inside the organization.',
        title: 'Internal Specific'
      },
      organizationWide: {
        description: 'This item is shared with everyone in the organization.',
        title: 'Organization Wide'
      },
      personalEmailShared: {
        description: 'This item is shared with a personal email address.',
        title: 'Personal Email Shared'
      },
      webPublished: {
        description: 'This item is published to the web and accessible without sign-in.',
        title: 'Web Published'
      }
    },
    riskLevel: {
      critical: 'Critical',
      high: 'High',
      low: 'Low',
      middle: 'Middle'
    },
    sidebar: {
      category: {
        permissionRisk: 'Permission Risk',
        sharingRisk: 'Sharing Risk'
      },
      closeSideTab: 'Close side tab',
      group: {
        riskCheckViolation: 'Risk Check Violation'
      },
      openSideTab: 'Open side tab',
      title: 'Alert categories'
    },
    title: 'Alerts',
    trashedLabel: 'Trash',
    unknownLabel: 'Unknown'
  },
  columns: {
    confidentialityLevel: 'Confidentiality Level',
    fileName: 'File name',
    folderName: 'Folder name',
    lastUpdateTime: 'Last Update Time',
    owner: 'Owner',
    parentFolder: 'Parent Folder',
    path: 'Path',
    permissionHolders: 'Permission Holders',
    users: 'User'
  },
  confidentialityLevel: {
    confidential: 'Confidential',
    highlyConfidential: 'Highly Confidential',
    internal: 'Internal',
    public: 'Public'
  },
  detail: {
    actions: {
      moreOptions: 'More options',
      viewOnProvider: 'View on {{provider}}'
    },
    attributes: {
      accessLevel: 'Access Level',
      accessRestriction: 'Access Restriction',
      administrator: 'Administrator',
      confidentialityLevel: 'Confidentiality Level',
      createdAt: 'Created At',
      fileName: 'File Name',
      fileSize: 'File Size',
      fileType: 'File Type',
      name: 'Name',
      owner: 'Owner',
      path: 'Path',
      provider: 'Provider',
      sharedLinkUrl: 'Shared Link URL',
      sourceUrl: 'Source URL',
      updatedAt: 'Updated At'
    },
    filePageTitle: 'File Details',
    folderPageTitle: 'Folder Details',
    navigation: {
      fileIdInformation: 'File ID Information',
      link: 'Link',
      sharedLink: 'Shared Link',
      structure: 'Structure',
      systemInformation: 'System Information'
    },
    sections: {
      basicInfo: 'Basic Information',
      ownerInfo: 'Owner Information',
      securitySettings: 'Security Settings'
    },
    tabs: {
      detail: 'Details',
      files: 'Files',
      overview: 'Overview',
      users: 'Users'
    },
    type: {
      file: 'File',
      folder: 'Folder'
    }
  },
  errors: {
    loadingFailed: 'Loading Failed',
    unknownError: 'An unknown error occurred'
  },
  filter: {
    driveSelect: {
      chipLabel: 'Select drives',
      chipLabelWithCount: 'Select drives ({{count}})',
      noResult: 'No matching drives',
      searchPlaceholder: 'Search drives'
    },
    driveType: {
      groupLabel: 'Drive type filter',
      personal: 'My Drive',
      shared: 'Shared Drive'
    },
    filesPlaceholder: 'Search files',
    placeholder: 'Search folders'
  },
  folder: {
    errors: {
      loadingFailed: 'Loading Failed'
    },
    files: {
      description: 'Files contained in this folder.',
      filter: {
        placeholder: 'Filter Files...'
      },
      title: 'Files'
    },
    users: {
      columns: {
        inheritanceSource: 'Inheritance Source',
        permissionHolder: 'Permission Holder',
        permissionHolderType: 'Permission Holder Type',
        permissionRole: 'Permission Role'
      },
      filter: {
        placeholder: 'Filter Users...'
      },
      holderTypes: {
        anyone: 'Anyone',
        domain: 'Domain',
        group: 'Group',
        individual: 'Individual'
      },
      roles: {
        coOwner: 'Co-Owner',
        editor: 'Editor',
        owner: 'Owner',
        previewer: 'Previewer',
        previewerUploader: 'Previewer Uploader',
        uploader: 'Uploader',
        viewer: 'Viewer',
        viewerUploader: 'Viewer Uploader'
      }
    }
  },
  provider: {
    box: 'Box',
    dropbox: 'Dropbox',
    googleDrive: 'Google Drive',
    oneDrive: 'OneDrive'
  },
  settings: {
    dialogAlert: {
      description: 'This operation may permanently delete data and cannot be undone.',
      okLabel: 'Start Integration',
      subDescription1: 'One-way import allows you to import data from an external source.',
      subDescription2: 'Importing data will replace existing data.',
      title: 'Storage Service Integration: One-way Import'
    },
    gwsConnection: {
      dialog: {
        description: 'Enter the Workspace domain and admin email required for Google Drive integration.',
        errors: {
          adminEmailFormat: 'Invalid email address format.',
          adminEmailRequired: 'Please enter the admin email address.',
          domainMismatch: 'The admin email domain must match the Workspace domain.',
          workspaceDomainFormat: 'Invalid domain format (e.g. example.com).',
          workspaceDomainRequired: 'Please enter the Workspace domain.'
        },
        helpText: {
          adminEmail: 'Enter the Super Admin email used for DWD impersonation.',
          workspaceDomain: 'Enter your Workspace primary domain (alias domains are not supported).'
        },
        labels: {
          adminEmail: 'Admin Email Address',
          lastUpdatedAt: 'Last Updated',
          workspaceDomain: 'Workspace Domain'
        },
        placeholders: {
          adminEmail: 'admin@example.com',
          workspaceDomain: 'example.com'
        },
        title: 'Google Workspace Connection Settings',
        toast: {
          saveSuccess: 'Google Workspace connection settings saved.'
        }
      },
      triggerAriaLabel: 'Edit Google Workspace connection settings'
    },
    pageDescription: 'Configure storage provider integration and synchronization settings.',
    pageTitle: 'Storage & Files Settings',
    providerConfiguration: {
      description: 'Configure your storage provider connection settings.',
      labels: {
        clientId: 'Client ID',
        connectedAt: 'Connected At',
        provider: 'Provider',
        status: 'Status'
      },
      reconfigure: 'Reconfigure',
      status: {
        connected: 'Connected',
        disconnected: 'Disconnected'
      },
      title: 'Provider Configuration'
    },
    sections: {
      providerConfiguration: 'Provider Configuration',
      syncSettings: 'Sync Settings'
    },
    syncSettings: {
      description: 'Configure automatic synchronization settings.',
      disabled: 'Disabled',
      enabled: 'Enabled',
      interval: {
        '1hour': 'Every hour',
        '6hour': 'Every 6 hours',
        '12hour': 'Every 12 hours',
        '15min': 'Every 15 minutes',
        '24hour': 'Every 24 hours',
        '30min': 'Every 30 minutes'
      },
      labels: {
        autoSync: 'Auto Sync',
        lastSyncAt: 'Last Synced At',
        syncInterval: 'Sync Interval'
      },
      syncNow: 'Sync Now',
      title: 'Sync Settings'
    },
    table: {
      addIntegration: 'Add Integration',
      columns: {
        lastSyncedAt: 'Last Synced At',
        noTenantName: 'No tenant',
        software: 'Software',
        syncEnabled: 'Sync Configuration',
        syncEnabledStatus: {
          disabled: 'Not configured',
          enabled: 'Configured'
        },
        syncStatus: 'Sync Status'
      },
      manualSync: 'Manual sync',
      setupSync: 'Setup sync',
      sync: 'Sync',
      syncConfigured: 'Sync configured',
      syncStarted: 'Sync started',
      syncing: 'Syncing...',
      title: 'Storage Integrations'
    }
  },
  tabs: {
    alerts: 'Alerts',
    files: 'Files',
    folders: 'Folders'
  },
  title: 'Storage & Files'
};